import { CompanyWithResearchUnits } from './company-with-research-group';
import { Poll } from './poll';
import { ResearchUnit } from './research-unit';
import { Target } from './target';

export class PollGroup {
  constructor(
    public hash?: string,
    public name?: string,
    public company?: CompanyWithResearchUnits,
    public target?: Target,
    public polls?: Poll[],
    public researchUnit?: ResearchUnit,
  ) { }

  clone() {
    return new PollGroup(
      this.hash,
      this.name,
      this.company,
      this.target,
      this.polls,
      this.researchUnit,
    );
  }
}
